<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M15.25 4H9.23999C8.82578 4 8.48999 4.33579 8.48999 4.75C8.48999 5.16421 8.82578 5.5 9.23999 5.5H13.4393L4.21967 14.7197C3.92678 15.0126 3.92678 15.4874 4.21967 15.7803C4.51256 16.0732 4.98744 16.0732 5.28033 15.7803L14.5 6.56067V10.76C14.5 11.1742 14.8358 11.51 15.25 11.51C15.6642 11.51 16 11.1742 16 10.76V4.75C16 4.73831 15.9997 4.72668 15.9992 4.71511C15.9855 4.41605 15.7967 4.16268 15.5329 4.05517C15.4456 4.0196 15.3501 4 15.25 4Z"
            fill="currentColor"
        />
    </svg>
</template>
